import React from 'react';
import styled from 'styled-components';
import { duration150, easeInOut } from '../../theme/animation';
import { fontSemiBold } from '../../theme/fonts';
import * as COLORS from '../../theme/colors';
import * as SCALE from '../../theme/scale';
import ColorWrapper from '../../typography/color-wrapper';
const Wrapper = styled(ColorWrapper)`
  align-items: center;
  background: transparent;
  border: 0;
  cursor: pointer;
  display: inline-flex;
  font-family: ${fontSemiBold};
  font-size: ${({
  fontSize
}) => fontSize ? SCALE[fontSize] : 'inherit'};
  padding: 0;
  transition: box-shadow ${duration150} ${easeInOut};

  &:focus {
    box-shadow: 0 0 0 3px ${COLORS.focusShadow};
    outline: none;
  }

  &:hover {
    cursor: pointer;
    ${({
  hoverColor
}) => hoverColor && `color: ${COLORS[hoverColor]};`}
  }

  &[disabled] {
    pointer-events: none;
    color: ${COLORS.gray400};
  }
`;
export const TextButton = ({
  children,
  onClick,
  color,
  hoverColor,
  fontSize,
  disabled = false,
  label
}) => {
  return /*#__PURE__*/React.createElement(Wrapper, {
    disabled: disabled,
    onClick: onClick,
    as: "button",
    color: color,
    fontSize: fontSize,
    hoverColor: hoverColor,
    "aria-label": label
  }, children);
};
export default TextButton;
//# sourceMappingURL=index.js.map